module.exports = __webpack_public_path__ + "static/img/ri-global-line.47736af6.svg";